import React, {Component} from "react";
import {Texts} from "../../texts";
import AppConfigContext, {AppConfigContextType} from "../../contexts/AppConfigContext";
import {FetchClasses} from "../../types";

export type RolledChildType = {
    role: string,
    props: any,
    children: string|null|any[]|"default",
    visible: boolean
}[];

abstract class FunctionDefinedComponents <PROPS,STATE> extends Component <PROPS,STATE>  {

    abstract rolledChildren():RolledChildType;
    appContext!:AppConfigContextType;
    modifiedChildren:any[]|null|undefined = [];
    texts!:Texts;
    theme!:"dark"|"light";
    fetch!:FetchClasses;
    branch!:number;

    componentDidMount() {
        this.setUpAppConfigContext();
        this.forceUpdate();
    };

    // Call on componentDidMount
    setUpAppConfigContext = () => {
        // @ts-ignore
        this.appContext = this.context;
        this.fetch = this.appContext.fetch;
        this.texts = this.appContext.texts;
        this.branch = this.appContext.branch;
        this.theme = this.appContext.theme;
    }

    // Call on componentDidMount (for render only once) or render method
    setUpChildren = () => {
        let props = this.props;
        // @ts-ignore
        this.modifiedChildren = React.Children.map(props.children, (child: any) => {
            let rv = child;
            this.rolledChildren().map((item, index)=>{
                if(child.props.role == item.role){
                    if(!item.visible)
                        rv = <></>;
                    else {
                        let ComDetails = this.rolledChildren().find(element => element.role == child.props.role);
                        ComDetails!.props.style = [ComDetails!.props.style, child.props.style];
                        if((ComDetails?.children ?? "default") == "default")
                            rv = React.cloneElement(child, ComDetails!.props);
                        else
                            rv = React.cloneElement(child, ComDetails!.props, ComDetails?.children);
                    }
                }
            });
            return rv;
        });
    }

    forceSecondRender(){
        this.setState({});
    }

    render() {
        this.setUpChildren();
        return <>
            {this.modifiedChildren}
        </>
    }
}

FunctionDefinedComponents.contextType = AppConfigContext;

export default FunctionDefinedComponents;